/* ++++++++++ --------------- HEADER : STYLES --------------- ++++++++++ */

import {pxToEm} from "@insticator/insticator-ui";

export default {
    informationSection:{
        display: 'flex',
        flexDirection: 'row',
        gap : pxToEm(8),
        '& > .message' : {
            fontFamily: '"Work Sans", sans-serif;',
            fontWeight: '500',
            lineHeight: pxToEm(22),
        }
    }
}